// Desc: Vehicle Creation Validation

import {
  emptyValidator,
  formValidator,
  yearMustBeLessThanCurrentValidator,
  dateMustBeGreaterThanTodayValidator,
  arrayNotEmptyValidator,
  greaterThanZeroValidator,
  vehicleNoValidator, dateMustBeGreaterThanTodayNMValidator,
} from "../../validators";

const vehicleValidationState = {
  vehVehicleNo: {
    validators: [emptyValidator(), vehicleNoValidator()],
    name: "Vehicle No",
  },
  vehBookRegNo: {
    validators: [emptyValidator()],
    name: "Book Registration No",
  },
  vehTransporter: {
    validators: [emptyValidator()],
    data: "",
    name: "Transporter",
  },
  vehBasedDriver: {
    validators: [emptyValidator()],
    name: "Base Driver",
  },
  vehBasedCity: {
    validators: [emptyValidator()],
    name: "Base City",
  },
  // vehBasedCompany: {
  //   validators: [emptyValidator()],
  //   name: "Base Company",
  // },
  vehWidth: {
    validators: [greaterThanZeroValidator()],
    name: "Width",
  },
  vehLength: {
    validators: [greaterThanZeroValidator()],
    name: "Length",
  },
  vehHeight: {
    validators: [greaterThanZeroValidator()],
    name: "Height",
  },
  vehSealPoints: {
    validators: [greaterThanZeroValidator()],
    name: "Body Type",
  },
  vehNextAvailableDate: {
    validators: [dateMustBeGreaterThanTodayNMValidator()],
    name: "Next Available Date",
  },
  vehStatus: {
    validators: [emptyValidator()],
    name: "Active",
  },
  vehActive: {
    validators: [emptyValidator()],
    name: "Status",
  },
  vehYearRegister: {
    validators: [yearMustBeLessThanCurrentValidator()],
    name: "Year of Register",
  },
  vehYearManufacturer: {
    validators: [yearMustBeLessThanCurrentValidator()],
    name: "Year of Manufacture",
  },
  vehInspectionTime: {
    validators: [emptyValidator()],
    name: "Inspection Time",
  },
  vehOperationalStatus:{
    validators: [emptyValidator()],
    name: "Vehicle Status",
  },
  vehInsuranceExpire: {
    validators: [emptyValidator()],
    name: "Insurance Expire Date",
  },
};

export const isInspectionDateRequired = (vehInspectionTime, inspectionTimeOpt = []) => {
  if (vehInspectionTime === undefined || vehInspectionTime === null || vehInspectionTime === "") {
    return false;
  }
  if (Array.isArray(inspectionTimeOpt) && inspectionTimeOpt.length > 0) {
    const selectedOpt = inspectionTimeOpt.find(
      (opt) =>
        String(opt?.value) === String(vehInspectionTime) ||
        String(opt?.key) === String(vehInspectionTime)
    );
    if (selectedOpt) {
      const text = String(selectedOpt.text || selectedOpt.label || "").trim().toLowerCase();
      if (
        text === "not required" ||
        text === "not_required" ||
        text === "not-required" ||
        text === "none"
      ) {
        return false;
      }
      return true;
    }
  }
  if (typeof vehInspectionTime === "string") {
    const text = vehInspectionTime.trim().toLowerCase();
    if (
      text === "not required" ||
      text === "not_required" ||
      text === "not-required" ||
      text === "none"
    ) {
      return false;
    }
  }
  return true;
};

export const vehicleValidation = (vehicle, inspectionTimeOpt = []) => {
  const errors = formValidator(vehicle, vehicleValidationState);

  const options =
    inspectionTimeOpt && inspectionTimeOpt.length > 0
      ? inspectionTimeOpt
      : vehicle?.inspectionTimeOpt;

  if (isInspectionDateRequired(vehicle?.vehInspectionTime, options)) {
    if (
      !vehicle?.vehLastServiceDate ||
      String(vehicle.vehLastServiceDate).trim() === ""
    ) {
      errors.vehLastServiceDate = "Last Inspection Date is required";
    }
    if (
      !vehicle?.vehNextInspectionDate ||
      String(vehicle.vehNextInspectionDate).trim() === ""
    ) {
      errors.vehNextInspectionDate = "Next Inspection Date is required";
    }
  }

  return errors;
};

const operationValidationState = {
  vpyCategory: {
    validators: [emptyValidator()],
    name: "Operation Category",
  },
  vpyType: {
    validators: [emptyValidator()],
    name: "Type",
  },
};

export const operationValidation = (operation) => {
  return formValidator(operation, operationValidationState);
};

const typeValidationState = {
  vetType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  vetCbm: {
    validators: [greaterThanZeroValidator()],
    name: "CBM",
  },
  vetMaxWeight: {
    validators: [greaterThanZeroValidator()],
    name: "Max Weight",
  },
  vehEmptyTruckWeight: {
    validators: [greaterThanZeroValidator()],
    name: "Empty Truck Weight",
  },
};

export const typeValidation = (type) => {
  return formValidator(type, typeValidationState);
};

const checkupValidationStatus = {
  vckType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  vckExpiry: {
    validators: [emptyValidator()],
    name: "Expiry / Next action date",
  },
  vckCondition: {
    validators: [emptyValidator()],
    name: "Condition",
  },
};

export const checkupValidation = (checkup) => {
  return formValidator(checkup, checkupValidationStatus);
};

const accidentValidationStatus = {
  vacCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  vacType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  vacDate: {
    validators: [emptyValidator()],
    name: "Date",
  },
  vacDriver: {
    validators: [emptyValidator()],
    name: "Driver",
  },
  vacAccidentStatus: {
    validators: [emptyValidator()],
    name: "Breakdown Status",
  },
};

export const accidentValidation = (accident) => {
  return formValidator(accident, accidentValidationStatus);
};

const documentValidationStatus = {
  docCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  fileType: {
    validators: [emptyValidator()],
    name: "File Type",
  },
  fileName: {
    validators: [emptyValidator()],
    name: "File Name",
  },
  docName: {
    validators: [emptyValidator()],
    name: "Document Name",
  },
  files: {
    validators: [arrayNotEmptyValidator()],
    name: "File",
  },
};

export const documentValidation = (document) => {
  return formValidator(document, documentValidationStatus);
};
